import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { PageLoaderService, UnsubscriberClass } from '@aston/foundation';
import * as RoutesDefinitions from 'apps/debtor-portal/src/app/routes-definitions';

@Injectable({
	providedIn: 'root'
})
export class AnonymousGuard extends UnsubscriberClass implements CanActivate {
	private pageLoaderService = inject(PageLoaderService);
	private router = inject(Router);


	canActivate(): Observable<boolean>|boolean {
		return this.isAuthenticated();
	}

	canLoad(): Observable<boolean>|boolean {
		return this.isAuthenticated();
	}

	private isAuthenticated(): Observable<boolean>|boolean {
		this.pageLoaderService.start();

		return of(true).pipe(
			takeUntil(this.destroySubscriptions$),
			map(isAuth => {
				this.pageLoaderService.end();

				if (isAuth) {
					this.router.navigate([RoutesDefinitions.getAccountingListFullPath()])
				}

				return !isAuth;
			})
		);
	}
}
